export function sentenceAround(text, word) {
  const haystack = String(text || "")
  const needle = String(word || "").trim()
  if (!haystack || !needle) return needle
  const idx = haystack.toLowerCase().indexOf(needle.toLowerCase())
  if (idx < 0) return needle
  const start = Math.max(0, haystack.lastIndexOf(".", idx) + 1)
  let end = haystack.indexOf(".", idx + needle.length)
  if (end < 0) end = haystack.length
  return haystack.slice(start, end + 1).trim()
}
